import { action, makeObservable, observable, reaction } from 'mobx';
import { userInfoStore } from '../../../store/userInfoStore';
import { applicationStore } from '../../../store/applicationStore';
import { footballDrawerService } from '../footballService/gameDrawerService';
import { isMobile } from '../../../core/helpers/isMobile';
import { freeBetStore } from '../../../store/freeBetStore';

class FootballBetsStore {
  isDoSpinStart = false;

  isBetsClosed = false;

  isAllowedNextReportInvoke = false;

  gameResult = null;

  cashOutWin = null;

  winAmount = null;

  winOdd = null;

  isAllowCashOut = false;

  lastResults = [];

  isHeldButton = false;

  constructor() {
    makeObservable(this, {
      winOdd: observable,
      winAmount: observable,
      gameResult: observable,
      cashOutWin: observable,
      lastResults: observable,
      isHeldButton: observable,
      isBetsClosed: observable,
      isDoSpinStart: observable,
      isAllowCashOut: observable,
      isAllowedNextReportInvoke: observable,
      setWinOdd: action.bound,
      setWinAmount: action.bound,
      setCashOutWin: action.bound,
      setGameResult: action.bound,
      setLastResults: action.bound,
      setIsHeldButton: action.bound,
      setIsBetsClosed: action.bound,
      setIsDoSpinStart: action.bound,
      updateLastResults: action.bound,
      setIsAllowCashOut: action.bound,
      setIsAllowedNextReportInvoke: action.bound,
    });
    reaction(
      () => applicationStore.isConnectionLost,
      (value) => {
        this.setIsHeldButton(false);
        if (value) {
          this.isBetsClosed = false;
          this.isAllowedNextReportInvoke = false;
          footballDrawerService.resetAnimations();
        }
      }
    );

    reaction(
      () => this.isDoSpinStart,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  setIsHeldButton(bool) {
    this.isHeldButton = bool;
  }

  setLastResults(results) {
    this.lastResults = results.map((el, index) => ({ ...el, id: index + 1 }));
  }

  updateLastResults(lastResult) {
    const updatedLastResult = [...this.lastResults, lastResult];
    if (updatedLastResult.length > (isMobile() ? 3 : 5)) {
      updatedLastResult.splice(0, 1);
    }
    const lastEl = updatedLastResult.pop();
    this.setLastResults(updatedLastResult);
    setTimeout(() => {
      this.setLastResults([...updatedLastResult, lastEl]);
    }, 10);
  }

  setIsAllowCashOut(bool) {
    this.isAllowCashOut = bool;
  }

  setCashOutWin(amount) {
    this.cashOutWin = amount;
  }

  setWinOdd(odd) {
    this.winOdd = odd;
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setGameResult(gameResult) {
    this.gameResult = gameResult;
  }

  setIsDoSpinStart(bool) {
    this.isDoSpinStart = bool;
  }

  setIsAllowedNextReportInvoke(bool) {
    this.isAllowedNextReportInvoke = bool;
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  resetStore() {
    this.isDoSpinStart = false;
    this.isBetsClosed = false;
    this.isAllowedNextReportInvoke = false;
    this.gameResult = null;
    this.cashOutWin = null;
    this.winAmount = null;
    this.winOdd = null;
    this.isAllowCashOut = false;
    this.lastResults = [];
    this.isHeldButton = false;
  }
}

export const footballBetsStore = new FootballBetsStore();
